'use client';

import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { userSystemSettingsAtom } from '@/store/userinfo';
import { useAudioManager } from '@/hooks/use-audio-manager';

/**
 * 音频 Provider 组件
 * 负责同步 store 中的音频设置到音频管理器
 */
export function AudioProvider({ children }: { children: React.ReactNode; }) {
  const userSystemSettings = useAtomValue(userSystemSettingsAtom);
  const {
    setMusicEnabled,
    setSoundEffectEnabled,
  } = useAudioManager();

  // 同步 store 中的音乐开关状态
  useEffect(() => {
    if (userSystemSettings?.musicSwitch !== undefined) {
      setMusicEnabled(userSystemSettings.musicSwitch);
    }
  }, [userSystemSettings?.musicSwitch, setMusicEnabled]);

  // 同步 store 中的音效开关状态
  useEffect(() => {
    if (userSystemSettings?.soundEffectSwitch !== undefined) {
      setSoundEffectEnabled(userSystemSettings.soundEffectSwitch);
    }
  }, [userSystemSettings?.soundEffectSwitch, setSoundEffectEnabled]);

  return <>{children}</>;
}

